import { SubString } from './../../models/Socket';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CCC } from '../../models/CCCFeed';

import * as SocketIO from 'socket.io-client';


/*
  Generated class for the PriceFeedProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class PriceFeedProvider {

  feed: Observable<CCC.Ticker>;
  socket: SocketIOClient.Socket;
  symbolMap: { [key: string]: Observable<CCC.Ticker> } = {};

  constructor() {
    this.initSocket();
  }

  private getNewSymbolObservable(socketSub: SubString): Observable<CCC.Ticker> {
    let subString = this.getStringFromSubscription(socketSub);
    this.socket.emit('SubAdd', { subs: [subString] });

    return new Observable(observer => {
      const subscription = this.feed
        .filter(val => {

          return val.MARKET == socketSub.market && val.TOSYMBOL == socketSub.to && val.FROMSYMBOL == socketSub.from
        })
        .subscribe(observer);

      return () => {
        subscription.unsubscribe();
        delete this.symbolMap[subString];
        this.socket.emit('SubRemove', { subs: [subString] });
      }
    }).share();
  }


  public getTicker(market: string, from: string, to: string): Observable<CCC.Ticker>{
    let sub = this.getSubscriptionString(market, from, to);
    return this.getObservableForSub(sub);
  }

  public getObservableForSub(socketSub: SubString): Observable<CCC.Ticker> {
    let subString = this.getStringFromSubscription(socketSub);
    if (!this.symbolMap[subString]) {
      this.symbolMap[subString] = this.getNewSymbolObservable(socketSub);
      // console.log('new entry for ' + subString);
    }
    return this.symbolMap[subString];
  }

  private getSubscriptionString(market: string, from: string, to: string): SubString {
    const sub: SubString = {
      market: market,
      from: from,
      to: to
    }
    return sub;
  }

  private getStringFromSubscription(sub: SubString): string{
    let type = (sub.market == 'CCCAGG'? 5 : 2);
    return `${type}~${sub.market}~${sub.from}~${sub.to}`;

  }

  private initSocket() {
    this.socket = SocketIO.connect('https://streamer.cryptocompare.com/');
    this.feed = new Observable<CCC.Ticker>(observer => {
      this.socket.on("m", function (message: string) {
        var messageType = message.substring(0, message.indexOf("~"));

        //THIS IS WHY
        if (messageType == CCC.types.CURRENTAGG || messageType == CCC.types.CURRENT) {
          let price = CCC.Current.unpack(message);
          observer.next(price);
        }
      });

      return () => {
      }
    }).share();
  }

}



// WEBPACK FOOTER //
// ./src/providers/price-feed/price-feed.ts